@if (!showSplashScreen()) {
   <router-outlet></router-outlet>
}
@if (themeService.currentThemeSettings().themeName === 'starwars' && (themeAnimationService.enableParticles$ | async) === true) {
   <shared-ui-component-star-wars-splash-screen [appLoading]="showSplashScreen()"></shared-ui-component-star-wars-splash-screen>
} @else {
   <shared-ui-component-splash-screen [show]="showSplashScreen()"></shared-ui-component-splash-screen>
}
